import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../stores/authStore';
import AdminDashboard from './AdminDashboard';
import AdminUsers from './AdminUsers';
import AdminStories from './AdminStories';
import AdminCharacters from './AdminCharacters';
import AdminUserDetail from './AdminUserDetail';
import AdminLibrary from './AdminLibrary';
import s from './AdminPages.module.css';

const TABS = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'users', label: 'Users' },
  { key: 'stories', label: 'Stories' },
  { key: 'characters', label: 'Characters' },
  { key: 'library', label: 'Library' },
];

export default function AdminPage() {
  const { user } = useAuthStore();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('dashboard');
  const [selectedUserId, setSelectedUserId] = useState(null);

  useEffect(() => {
    if (user && !user.is_admin) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  if (!user?.is_admin) {
    return (
      <div className={s.loading}>
        <p>Checking access...</p>
      </div>
    );
  }

  function handleViewUser(id) {
    setSelectedUserId(id);
    setActiveTab('user-detail');
  }

  function handleBackToUsers() {
    setSelectedUserId(null);
    setActiveTab('users');
  }

  return (
    <div className={s.layout}>
      {/* Sidebar */}
      <aside className={s.sidebar}>
        <div className={s.sidebarHeader}>
          <span className={s.logo}>LP</span>
          <span className={s.logoText}>Admin</span>
        </div>
        <nav className={s.nav}>
          {TABS.map((tab) => (
            <button
              key={tab.key}
              onClick={() => { setActiveTab(tab.key); setSelectedUserId(null); }}
              className={`${s.navItem} ${
                activeTab === tab.key || (tab.key === 'users' && activeTab === 'user-detail')
                  ? s.navItemActive
                  : ''
              }`}
            >
              {tab.label}
            </button>
          ))}
          {/* Map Atlas editor lives on its own lazy route (BP-MAP-ATLAS-03). */}
          <button
            onClick={() => navigate('/admin/map-atlas-editor')}
            className={s.navItem}
          >
            Map Atlas
          </button>
        </nav>
        <div className={s.sidebarFooter}>
          <button onClick={() => navigate('/')} className={s.backLink}>
            Back to app
          </button>
        </div>
      </aside>

      {/* Main content */}
      <main className={s.main}>
        {activeTab === 'dashboard' && <AdminDashboard />}
        {activeTab === 'users' && <AdminUsers onViewUser={handleViewUser} />}
        {activeTab === 'user-detail' && selectedUserId && (
          <AdminUserDetail userId={selectedUserId} onBack={handleBackToUsers} />
        )}
        {activeTab === 'stories' && <AdminStories />}
        {activeTab === 'characters' && <AdminCharacters />}
        {activeTab === 'library' && <AdminLibrary />}
      </main>
    </div>
  );
}
